import { CellProps } from 'react-table'
import { PlainHeader, sortableColumn, StackedCell, StatusBadge, TableColumn } from 'app/components'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { ExameList } from '../../core/_models'
import { ExamesActionsCell } from './ExamesActionsCell'
import { TFunction } from '_metronic/i18n/Metronici18n'

export const examesColumns = (t: TFunction): ReadonlyArray<TableColumn<ExameList>> => [
  // Coluna do botão de expandir (o ModernTable desenha o botão na coluna de id `expand`).
  {
    Header: () => <span className='visually-hidden'>Detalhes</span>,
    id: 'expand',
    cellWidth: '56px',
  },
  // Nome com o código como apoio; os dois seguem ordenáveis.
  sortableColumn<ExameList>({
    id: 'nome',
    useQueryRequest,
    fields: [
      { field: 'nome', label: t('cols.nome') },
      { field: 'codigo', label: t('cols.codigo') },
    ],
    Cell: ({ row }: CellProps<ExameList>) => (
      <StackedCell primary={row.original.nome} secondary={row.original.codigo} />
    ),
  }),
  sortableColumn<ExameList>({
    id: 'tipo',
    cellWidth: '200px',
    hideOnMobile: true,
    useQueryRequest,
    fields: [{ field: 'tipo', label: t('cols.tipo') }],
    Cell: ({ row }: CellProps<ExameList>) => <StackedCell primary={row.original.tipo} />,
  }),
  sortableColumn<ExameList>({
    id: 'apac',
    cellWidth: '96px',
    hideOnMobile: true,
    useQueryRequest,
    fields: [{ field: 'apac', label: t('apac.label') }],
    Cell: ({ row }: CellProps<ExameList>) => (
      <StackedCell primary={row.original.apac ? 'Sim' : 'Não'} />
    ),
  }),
  sortableColumn<ExameList>({
    id: 'ativo',
    cellWidth: '128px',
    useQueryRequest,
    fields: [{ field: 'ativo', label: t('cols.situacao') }],
    Cell: ({ row }: CellProps<ExameList>) => <StatusBadge active={row.original.ativo} />,
  }),
  {
    Header: () => <PlainHeader>{t('cols.actions')}</PlainHeader>,
    id: 'actions',
    cellWidth: '132px',
    align: 'end',
    Cell: ({ row }: CellProps<ExameList>) => <ExamesActionsCell exame={row.original} />,
  },
]
